import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EmptyState } from '@/components/custom/empty-state';
import { usePlatformAbilities } from '@/hooks/usePlatformAbilities';

// Espelha as condições de render das seções de conteúdo do DashboardStudent
// (guia de estudo, desafio da semana, aula ao vivo, último curso acessado).
// Ao adicionar uma nova seção na dashboard, incluir a condição dela aqui —
// senão o empty state aparece junto com a seção nova.
export function hasDashboardContent({ lastStudyPlan, lastChallenge, liveClassroom, lastCourseWatched }) {
  return Boolean(lastStudyPlan?.video || lastChallenge || liveClassroom || (lastCourseWatched && Object.keys(lastCourseWatched).length > 0));
}

export function DashboardEmptyState() {
  const navigate = useNavigate();
  const { abilities } = usePlatformAbilities();

  return (
    <EmptyState
      type="content"
      variant="plain"
      title="Nenhum conteúdo disponível ainda."
      text="Assim que os professores liberarem cursos, desafios e aulas para a sua turma, tudo aparecerá aqui."
      cta={abilities?.cursos ? { text: 'Explorar cursos', onClick: () => navigate('/curso') } : undefined}
      className="w-[420px] py-16"
    />
  );
}
